import { FaClock, FaCommentDots } from "react-icons/fa";
import { ImHammer2 } from "react-icons/im";

const PredefinedReasonBan = ({predefinedReason, onClick}) => {
    return (
        <div className="flex items-center mb-2">
            <div onClick={() => onClick(predefinedReason)} className="remoteAdminButton predefinedReasonBanButton">
                <ImHammer2 className="mr-2"/> Ban 
                [<FaClock className="mx-[2px]"/> <div className="normal-case">{predefinedReason.time}</div>]      
            </div>
            <FaCommentDots size={"25px"} className="mx-4"/>{predefinedReason.reason}
        </div>
    )
}

export default PredefinedReasonBan;